import { useState, useEffect } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { supabase } from '@/integrations/supabase/client';

export function useStreakMigration() {
  const { user } = useAuth();
  const [shouldShowModal, setShouldShowModal] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setLoading(false);
      return;
    }

    checkMigrationStatus();
  }, [user]);

  const checkMigrationStatus = async () => {
    try {
      // Check if user has already set their reading preference
      const { data: prefs } = await supabase
        .from('user_reading_preferences')
        .select('weekly_reading_goal')
        .eq('user_id', user!.id)
        .maybeSingle();

      // Check if user has an existing streak (so they're not brand new)
      const { data: streak } = await supabase
        .from('user_streaks')
        .select('current_streak')
        .eq('user_id', user!.id)
        .maybeSingle();

      // Show modal if:
      // 1. User doesn't have weekly_reading_goal set yet (null or undefined)
      // 2. User has an existing streak (not a brand new user)
      // Note: New users set their weekly goal during onboarding, so they skip this modal
      const shouldShow = !prefs?.weekly_reading_goal && !!streak;
      setShouldShowModal(shouldShow);
    } catch (error) {
      console.error('Error checking migration status:', error);
    } finally {
      setLoading(false);
    }
  };

  const dismissModal = () => {
    setShouldShowModal(false);
  };

  return {
    shouldShowModal,
    dismissModal,
    loading,
  };
}
